import React from "react";

export default function InstrumentPlaceholderIcon() {
    return <svg xmlns="http://www.w3.org/2000/svg" width="128" height="128" viewBox="0 0 128 128">
  <g id="Placeholder_Instrument_v2" transform="translate(-1168 -1545)">
    <rect id="Rechteck_250" data-name="Rechteck 250" width="128" height="128" transform="translate(1168 1545)" fill="none"/>
    <g id="Placeholder_Instrument" transform="translate(900.333 203.136)">
      <path id="Pfad_1276" data-name="Pfad 1276" d="M14.586,66.45a16.073,16.073,0,0,1,9.39,2.65L15.492,0S42.161,15.808,45.686,34.683,32.968,61.518,32.968,61.518s11.372-8.832,8.794-20.674S22.594,24.333,22.594,24.333s6.579,52.575,6.579,53.578c0,6.33-6.531,11.461-14.586,11.461S0,84.24,0,77.91,6.531,66.45,14.586,66.45Z" transform="translate(314.191 1358.697) rotate(7)" fill="currentColor"/>
    </g>
  </g>
</svg>;
}